import React from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useLearningMode } from '../../contexts/LearningModeContext';
import { findHelpItem } from '../../help/modules';

interface HelpHintProps {
  /** `modul.elem` alakú hivatkozás a help/modules.ts-ben leírt elemre, pl. 'events.filters'. */
  id: string;
  className?: string;
}

/**
 * Kis ? jel egy gomb vagy mező mellett, ami tanuló módban elmagyarázza az
 * elemet. Kikapcsolt tanuló módban semmit nem rajzol, így bárhová tehető.
 */
const HelpHint: React.FC<HelpHintProps> = ({ id, className = '' }) => {
  const { enabled } = useLearningMode();
  const found = findHelpItem(id);

  if (!enabled) return null;
  if (!found) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`HelpHint: nincs leírás ehhez: "${id}" (help/modules.ts)`);
    }
    return null;
  }

  return (
    <Popover className={`relative inline-flex ${className}`}>
      <PopoverButton
        aria-label={`Mi ez: ${found.item.label}`}
        className="inline-flex h-6 w-6 items-center justify-center rounded-full text-primary-600 ring-2 ring-primary-200 ring-offset-1 hover:bg-primary-50 focus:outline-none focus-visible:ring-primary-500"
      >
        <QuestionMarkCircleIcon className="h-5 w-5" />
      </PopoverButton>
      <PopoverPanel
        anchor={{ to: 'bottom', gap: 8, padding: 16 }}
        className="z-50 w-72 rounded-lg bg-gray-900 p-3 text-sm text-white shadow-lg"
      >
        <p className="font-semibold">{found.item.label}</p>
        <p className="mt-1 text-gray-200">{found.item.text}</p>
      </PopoverPanel>
    </Popover>
  );
};

export default HelpHint;
